import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EnrollmentFormService } from '../../../../../../services/EnrollmentFormService';
import { PortalService } from '../../../../../../services/portal.service';
import { EnrollmentComponent } from '../enrollment/enrollment.component';
import { environment } from '../../../../../../environments/environment';
import { TelemetryService } from '../../../../../../services/telemetry.service';

@Component({
	selector: 'app-patient-info',
	templateUrl: './patient-info.component.html',
	styleUrls: ['./patient-info.component.scss']
})
export class PatientInfoComponent implements OnInit {

	patientInfoForm!: FormGroup
	states: any;
	isSubmitted: boolean = false;
	patientAccountID: any;
	drugDetails: { drugName: string | null; drugID: number | null } | null = null;
	currentSequenceStep: string;
	patientSubgroup: any;
	//group: FormGroup<any>;
	enrollmentId: string;
	isLoading: boolean = false;
	isDisabled: boolean = false;
	EmailID: string;
	sameAddressControl = new FormControl(false);

	constructor(
		private activatedRoute: ActivatedRoute,
		private fb: FormBuilder,
		private portalService: PortalService,
		private router: Router,
		private efs: EnrollmentFormService,
		private telemetryService:TelemetryService,
		private enrollmentComponent: EnrollmentComponent) {
		this.patientInfoForm = this.efs.enrollmentForm as FormGroup;

	}

	ngOnInit() {
		//this.patientInfoForm.disable();
		this.EmailID = localStorage.getItem('email');
		this.patientSubgroup = new FormGroup({
			firstName: this.patientInfoForm.get('firstName') || new FormControl(''),
			lastName: this.patientInfoForm.get('lastName') || new FormControl(''),
			birthdate: this.patientInfoForm.get('birthdate') || new FormControl(''),
			email: this.patientInfoForm.get('email') || new FormControl(''),
			phone: this.patientInfoForm.get('phone') || new FormControl(''),
			altPhone: this.patientInfoForm.get('altPhone') || new FormControl(''),
			billingAddress1: this.patientInfoForm.get('billingAddress1') || new FormControl(''),
			billingAddress2: this.patientInfoForm.get('billingAddress2') || new FormControl(''),
			billingCity: this.patientInfoForm.get('billingCity') || new FormControl(''),
			billingState: this.patientInfoForm.get('billingState') || new FormControl(''),
			billingZip: this.patientInfoForm.get('billingZip') || new FormControl('', [Validators.required, Validators.pattern(/^\d{5}$/)]),
			shippingAddress1: this.patientInfoForm.get('shippingAddress1') || new FormControl(''),
			shippingAddress2: this.patientInfoForm.get('shippingAddress2') || new FormControl(''),
			shippingCity: this.patientInfoForm.get('shippingCity') || new FormControl(''),
			shippingState: this.patientInfoForm.get('shippingState') || new FormControl(''),
			shippingZip: this.patientInfoForm.get('shippingZip') || new FormControl('', [Validators.required, Validators.pattern(/^\d{5}$/)]),
			usCitizen: this.patientInfoForm.get('usCitizen') || new FormControl(false),
			gender: this.patientInfoForm.get('gender') || new FormControl(''),
		});

		this.sameAddressControl.disable();
		this.activatedRoute.paramMap.subscribe(params => {
			if (params.get('id')) this.enrollmentId = params.get('id');
		});
		this.currentSequenceStep = localStorage.getItem('CurrentEnrollmentStep');
		if (this.enrollmentId || this.efs?.currentEnrollmentObject?.enrollmentId) {
			this.efs.setEnrollmentID(+this.enrollmentId || this.efs?.currentEnrollmentObject?.enrollmentId);
			this.efs.checkAndfetchEnrollmentDetails(this.enrollmentId || this.efs?.currentEnrollmentObject?.enrollmentId);
			// this.getProfileDetails();
			this.sameAddressControl.setValue(this.isSameAsHomeAddress(this.patientInfoForm.value));
		} else {
			this.loadProfileData();
		}
		this.patientAccountID = localStorage.getItem('patientAccountId');
		this.efs.drugDetails$.subscribe((details) => {
			this.drugDetails = details;
			console.log('Received drug details:', details);
		});

		// this.patientInfoForm.get('sameAsHomeAddress')?.valueChanges.subscribe((value) => {
		// 	this.onToggleChange(value);
		// });
		this.portalService.getStatesList().subscribe({
			next: (data) => {
				this.states = data;
			},
			error: (err) => {
				console.error('Error loading states:', err);
			}
		});
		// if(localStorage.getItem('newEnrollment') == 'true'){
		//   console.log('newenrollment? ',localStorage.getItem('newEnrollment') == 'true');
		//   //this.efs.resetForm();
		//   //this.loadProfileData();
		// }
	}

	get nextStep() {
		return this.efs.getNextStep();
	}

	isSameAsHomeAddress(data: any) {
		let result = true;
		if (data.billingAddress1 !== data.shippingAddress1 || data.billingAddress2 !== data.shippingAddress2 ||
			data.billingCity !== data.shippingCity || data.billingState !== data.shippingState || data.billingZip !== data.shippingZip
		) {
			result = false;
		}
		return result;
	}

	loadProfileData(): void {
		this.isLoading = true;
		this.portalService.getPatientAccountDetail(this.EmailID).subscribe(
			(data: any) => {
				this.patchForm(data);
			},
			(error: any) => {
				this.isLoading = false;
				console.error('Error loading profile data:', error);
			}
		);
	}

	// getProfileDetails() {
	//   this.portalService.getEnrollmentById(null, this.enrollmentId).subscribe((res) => {
	//     this.patchForm(res);
	//   });
	// }

	patchForm(data: any) {
		this.isLoading = false;
		this.patientInfoForm.patchValue({
			enrollmentId: data.enrollmentId,
			drugName: data.drugName || "",
			drugID: data.drugID || "",
			firstName: data.firstName,
			lastName: data.lastName,
			birthdate: data.birthdate,
			email: data.email,
			phone: data.phoneNumber || data.phone,
			primaryPhoneTypeId: data.primaryPhoneTypeId,
			altPhone: data.altPhone,
			alternatePhoneTypeId: data.alternatePhoneTypeId,
			billingAddress1: data.billingAddress1,
			billingAddress2: data.billingAddress2,
			billingCity: data.billingCity,
			billingState: data.billingState,
			billingZip: data.billingZip,
			shippingAddress1: data.shippingAddress1,
			shippingAddress2: data.shippingAddress2,
			shippingCity: data.shippingCity,
			shippingState: data.shippingState,
			shippingZip: data.shippingZip,
			// sameAsHomeAddress: [this.isSameAsHomeAddress(data)],
			gender: data.gender,
			usCitizen: data.usCitizen,
		});

		this.sameAddressControl.setValue(this.isSameAsHomeAddress(data));

		// Subscribe to sameAsHomeAddress toggle changes
		this.sameAddressControl?.valueChanges.subscribe((value) => {
			this.onToggleChange(value);
		});
	}

	onSave(isSaveAndExit = false): void {
		if(!isSaveAndExit) {
			this.telemetryService.logEvent('Next Button Clicked', {
				step: this.nextStep.enrollmentStepName,
				timestamp: new Date().toISOString(),
			});
		}

		this.isLoading = true;
		if (!this.enrollmentId) {
			this.patientInfoForm.patchValue({
				patientAccountId: this.patientAccountID,
				programId: environment.programID,
				programURL: environment.programURL,
				drugID: this.enrollmentId ? this.patientInfoForm.value.drugID : this.drugDetails.drugID,
				drugName: this.enrollmentId ? this.patientInfoForm.value.drugName : this.drugDetails.drugName,
				isClassII: true,
				lastEnrollmentStep: this.currentSequenceStep
			});
		}
		if (this.patientInfoForm.value) {
			const eid = this.patientInfoForm.get('enrollmentId')?.value || 0;
			console.log(this.patientInfoForm.value);
			this.portalService.createEnrollment(this.patientInfoForm.value, eid).subscribe((value: any) => {
				this.isLoading = false;
				this.efs.patchEnrollmentForm(value);
				if (!this.enrollmentId) {
					this.efs.setEnrollmentID(value.enrollmentId);
					this.patientInfoForm.patchValue({
						enrollmentId: value.enrollmentId
					});
				}
				if (isSaveAndExit) {
					this.efs.resetForm();
					this.router.navigate(['/submissions'], { relativeTo: this.activatedRoute });
				} else {
					if (this.enrollmentId) {
						this.router.navigate([`../${this.nextStep.enrollmentRoute}`], { relativeTo: this.activatedRoute });
						this.enrollmentComponent.setCurrentStep(this.nextStep.enrollmentStepName, 'true');
					} else {
						localStorage.setItem('newEnrollment', 'false');
						this.enrollmentComponent.setCurrentStep(this.nextStep.enrollmentStepName);
					}
				}
			});
		}
	}

	clear(): void {
		this.patientInfoForm.reset({
			enrollmentId: 0,
			firstName: '',
			lastName: '',
			birthdate: '',
			email: '',
			type: '',
			phone: '',
			alternateType: '',
			altPhone: '',
			usCitizen: '',
			gender: '',
			billingAddress1: '',
			billingAddress2: '',
			billingCity: '',
			billingState: '',
			billingZip: '',
			shippingAddress1: '',
			shippingAddress2: '',
			shippingCity: '',
			shippingState: '',
			shippingZip: '',
		});
		this.patientInfoForm.markAsUntouched();
		this.patientInfoForm.markAsPristine();
	}

	onToggleChange(value: boolean): void {
		if (value) {
			this.patientInfoForm.patchValue({
				shippingAddress1: this.patientInfoForm.get('billingAddress1')?.value,
				shippingAddress2: this.patientInfoForm.get('billingAddress2')?.value,
				shippingCity: this.patientInfoForm.get('billingCity')?.value,
				shippingState: this.patientInfoForm.get('billingState')?.value,
				shippingZip: this.patientInfoForm.get('billingZip')?.value
			});
		} else {
			this.patientInfoForm.patchValue({
				shippingAddress1: '',
				shippingAddress2: '',
				shippingCity: '',
				shippingState: '',
				shippingZip: ''
			});
		}
		this.patientInfoForm.updateValueAndValidity();
		this.patientSubgroup.updateValueAndValidity();
	}
}
